import React from 'react';
import ExperiencePage from '../components/ExperiencePage';

const WorldPay = () => {
  return (
    <ExperiencePage
      company="WorldPay"
      role="Software Engineer"
      period="September 2013 - July 2018"
      description={[
        "Developed 8 web and backend services in Java with quality; company achieved 99.999% uptime milestone.",
        "Led 3 major initiatives defining technical architecture, highlighting risks, and breaking down user stories.",
        "Developed customer facing test transaction suite for certification, health-checks, and onboarding."
      ]}
    />
  );
};

export default WorldPay;
